import { Injectable } from '@angular/core';
import { Headers, Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppConstants } from '../core/app.constants';
import { ReportsConfigResponse } from '../core/core.component';

@Injectable()
export class ReportService {
  constructor(private http: Http) {}

  getConfig(srmToken): Observable<ReportsConfigResponse> {
    const url = AppConstants.urlForNoCache(environment.REST_SERVICE_BASE_URL + '/reports/config');
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.get(url, {headers: headers}).map((responseData) => responseData.json());
  }

  exportReport(srmToken, reportClass: string, parameters: Object): Observable<any> {
    const url = AppConstants.urlForNoCache(environment.REST_SERVICE_BASE_URL + '/reports/report');
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    headers.append('Content-Type', 'application/vnd.ms-excel');
    headers.append('Accept', 'application/vnd.ms-excel');
    const params: URLSearchParams = new URLSearchParams();
    params.set('reportClass', reportClass);
    Object.keys(parameters).forEach(key => params.set(key, parameters[key]));
    return this.http.get(url, {search: params, headers: headers, responseType: ResponseContentType.Blob}).map(res => res.blob());
  }

  exportReportWithHeaders(srmToken, reportClass: string, parameters: Object): Observable<any> {
    const url = AppConstants.urlForNoCache(environment.REST_SERVICE_BASE_URL + '/reports/report');
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    headers.append('Content-Type', 'application/vnd.ms-excel');
    headers.append('Accept', 'application/vnd.ms-excel');
    const params: URLSearchParams = new URLSearchParams();
    params.set('reportClass', reportClass);
    Object.keys(parameters).forEach(key => params.set(key, parameters[key]));

    return this.http.get(url, {
      search: params,
      headers: headers,
      responseType: ResponseContentType.Blob
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/service/report.service.ts